/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type AgelessAssessmentFlowType =
  (typeof AgelessAssessmentFlowType)[keyof typeof AgelessAssessmentFlowType];

export const AgelessAssessmentFlowType = {
  Aesthetics: "Aesthetics",
  Wellness: "Wellness",
  AestheticsWellness: "AestheticsWellness",
  LashBrow: "LashBrow",
} as const;
